import appService from '@/services/app.service';

const updateAgency = (agencyId, payload) => {
  return appService.put(`/agencies/${agencyId}`, payload);
};

export const agencyService = {
  updateAgency,
};
